function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { spacing8, white, sans, text120, boxShadowRaised } from "@churchofjesuschrist/eden-style-constants";
export const InternalOnlyCardStyled = styled.a.withConfig({
  componentId: "sc-1w8ay07-0"
})(["text-decoration:none;display:inline-block;padding:", ";background-color:", ";box-shadow:", ";color:", ";font-family:", ";width:100%;&:hover{color:", ";box-shadow:", ";text-decoration:none;}"], spacing8, white, boxShadowRaised, text120, sans, text120, boxShadowRaised);
const Card = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(InternalOnlyCardStyled, _extends({}, props, {
    ref: ref
  }), children);
});
Card.displayName = "Card";
Card.propTypes = {
  /** Card contents */
  children: PropTypes.node.isRequired
};
export default Card;